"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Sets the input text of the IncludesWordsInput text field
 * @param clauseId the id of the clause that corresponds to the input
 * @param inputText the current text in the input field
 */
exports.default = legacy_1.action('setIncludesWordsInputText')(function setIncludesWordsInputText(clauseId, inputText) {
    store_1.default.inboxRulesEditState.includesWordsInputTextMap.set(clauseId, inputText);
});
//# sourceMappingURL=setIncludesWordsInputText.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/setIncludesWordsInputText.js
// module id = 3749
// module chunks = 2